/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { request } from '../request'
import type { RequestResponse } from '../request'
import type {
  GetProjectInfoParams,
  ProjectInfoModel,
  SaveProjectInfoParams,
  ExportProjectProgressInfoParams,
  ExportProjectInfoParams,
  ExportRendersProjectInfoParams,
  ProjectProgress,
  AddSegmentParams,
  UpdateProjectCoverParams,
  BatchRenderParams,
  BatchRenderModel,
  SubmitBatchRenderParams,
  ProjectSegmentModel,
  BatchRenderStatusModel,
  ProjectModel,
  updateProjectConfigParams,
  ProjectConfigModel,
  TranslateSegmentsParams,
  updateSpeechParams,
  VocalSeparationParams,
  VocalSeparationResult,
  ParserSubtitleFile,
} from './type'
import { AssetType } from '@ve-pro/enums/asset'
import _ from 'lodash'

// 获取项目详情
export const getProjectInfo = (params?: GetProjectInfoParams) =>
  request.get<RequestResponse<ProjectInfoModel>>('veditor/project/info', {
    params,
  })

// 保存项目
export const saveProject = (params: SaveProjectInfoParams) => {
  return request.post<RequestResponse<string>>(
    'veditor/project/save',
    {
      ...params,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )
}

// 导出进度
export const exportProjectProgress = (
  params: ExportProjectProgressInfoParams,
) =>
  request.get<RequestResponse<ProjectProgress>>('veditor/project/render-list', {
    params,
  })

// 导出接口
export const exportProject = (data: ExportProjectInfoParams) =>
  request.post<RequestResponse<string>>('veditor/project/render', data, {
    headers: {
      'Content-Type': 'application/json',
    },
  })

// 快速替换导出接口
export const exportRendersProject = (data: ExportRendersProjectInfoParams) =>
  request.post<RequestResponse<string>>('veditor/tpl-video/renders', data, {
    headers: {
      'Content-Type': 'application/json',
    },
  })

// 快速替换编辑更多
export const replaceProjectEditMore = (data: { id: number; name: string }) =>
  request.post<RequestResponse<string>>('veditor/tpl-video/edit-more', data, {
    headers: {
      'Content-Type': 'application/json',
    },
  })

export const apiAddSegment = (data: AddSegmentParams) =>
  request.post<RequestResponse<{ segments: ProjectSegmentModel[] }>>(
    'veditor/project/add-segment',
    Object.assign(
      {},
      data,
      data.type === AssetType.Text ? { text: data.text } : {},
    ),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )

export const updateProjectCover = (data: UpdateProjectCoverParams) =>
  request.post<RequestResponse<string>>('veditor/project/update-cover', data, {
    headers: {
      'Content-Type': 'application/json',
    },
  })

/** 批量导出列表  */
export const batchRenderList = (params: BatchRenderParams) =>
  request.get<RequestResponse<BatchRenderModel>>(
    'veditor/batch-render/renders',
    {
      params,
    },
  )

export const submitBatchRender = (data: SubmitBatchRenderParams) =>
  request.post<RequestResponse<string>>('veditor/batch-render/submit', data, {
    headers: {
      'Content-Type': 'application/json',
    },
  })

export const getRenderStatus = (
  params: Pick<BatchRenderParams, 'project_id'>,
) =>
  request.get<RequestResponse<BatchRenderStatusModel>>(
    'veditor/batch-render/render-status',
    {
      params,
    },
  )

// 获取项目配置
export const getProjectConfig = (params: { id: ProjectModel['id'] }) =>
  request.get<RequestResponse<ProjectConfigModel>>('veditor/project/config', {
    params,
  })

// 更新项目配置
export const updateProjectConfig = (data: updateProjectConfigParams) =>
  request.post<RequestResponse<string>>('veditor/project/config', data, {
    headers: {
      'Content-Type': 'application/json',
    },
  })

// 批量翻译项目元件
export const translateSegments = (data: TranslateSegmentsParams) =>
  request.post<RequestResponse<number>>(
    'veditor/project/translate-segments',
    Object.assign({ slice: false }, _.cloneDeep(data)),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )

// 批量更新项目元件 updateSpeechResult
export const updateSpeech = (data: updateSpeechParams) =>
  request.post<RequestResponse<number>>('veditor/project/update-speech', data, {
    headers: {
      'Content-Type': 'application/json',
    },
  })

// 音频人声分离
export const vocalSeparation = (data: VocalSeparationParams) =>
  request.post<RequestResponse<VocalSeparationResult>>(
    'veditor/project/vocal-separation',
    data,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )

// 字幕文件识别
export const parserSubtitleFile = (data: { url: string }) =>
  request.post<RequestResponse<ParserSubtitleFile>>(
    'veditor/project/subtitle-parser',
    data,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )
